import {useEffect} from 'react';
import {Storage, useSelector} from '@utils';
import {
    UseProblemsOfTheDayOptions,
    useProblemsOfTheDay,
} from './useProblemsOfTheDay';

type RecoveryStorageData = {
    date: string;
    requiredSolves: number;
};

export const useStreakRecoveryStorage = (
    options?: UseProblemsOfTheDayOptions
) => {
    const {user} = useSelector(s => s.auth);
    const potdQuery = useProblemsOfTheDay(options);
    const potdData = potdQuery.currentData;

    const recoveryStorageKey = `potd_streak_recovery_${user?.id ?? 0}`;
    const todayStr = new Date().toISOString().slice(0, 10);

    const recovery = potdData?.streakRecovery;
    const solvedToday =
        potdData?.entries?.filter(e => e.solvedByCurrentUser)?.length ?? 0;

    useEffect(() => {
        if (recovery?.needsRepair) {
            Storage.storeObjData(recoveryStorageKey, {
                date: todayStr,
                requiredSolves: recovery.requiredSolves,
            });
        }
    }, [recovery, recoveryStorageKey, todayStr]);

    const lsRecovery =
        Storage.getObjData<RecoveryStorageData>(recoveryStorageKey);
    const activeRecovery =
        recovery ?? (lsRecovery?.date === todayStr ? lsRecovery : null);

    const isRepaired =
        activeRecovery !== null &&
        solvedToday >= (activeRecovery?.requiredSolves ?? Infinity);
    const needsRepair = !!recovery?.needsRepair && !isRepaired;

    return {
        recovery,
        activeRecovery,
        isRepaired,
        needsRepair,
        solvedToday,
        recoveryStorageKey,
        todayStr,
        potdData,
        potdQuery,
    };
};
